/** True when this browser can stream an export to disk. */
export function canSaveToDisk() {
    return typeof window !== 'undefined' && typeof window.showSaveFilePicker === 'function';
}
/**
 * Ask the reader where to save the export, when the browser can stream to
 * disk; a browser that cannot gets the in-memory target without a prompt.
 *
 * MUST be called from the click handler before anything is awaited: the save
 * picker needs a fresh user gesture, and fetching a study first would spend it.
 *
 * Resolves to null when the reader cancels the picker (nothing to save, nothing
 * to report). Any other failure of the picker (a sandboxed frame, a policy)
 * falls back to the in-memory target rather than refusing the export.
 */
export async function pickSaveTarget(suggestedName, mime, extension) {
    if (!canSaveToDisk())
        return { kind: 'blob' };
    let handle;
    try {
        handle = await window.showSaveFilePicker({
            suggestedName,
            types: [{ description: extension.toUpperCase(), accept: { [mime]: [`.${extension}`] } }],
        });
    }
    catch (err) {
        if (err instanceof DOMException && err.name === 'AbortError')
            return null;
        return { kind: 'blob' };
    }
    try {
        const writable = await handle.createWritable();
        return { kind: 'file', name: handle.name || suggestedName, writable };
    }
    catch {
        return { kind: 'blob' };
    }
}
